module.exports = __webpack_public_path__ + "img/quizmayhem_banner_frozen.0ab58510.jpg";